/* eslint no-use-before-define: 0 */ // --> OFF
/* eslint no-var: 0 */ // --> OFF
/* eslint no-unused-vars: 0 */ // --> OFF
/* eslint default-case: 0 */ // --> OFF
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _extends =
    Object.assign ||
    function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };

var _createClass = (function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
})();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Async = require('./Async');

var _Async2 = _interopRequireDefault(_Async);

var _Creatable = require('./Creatable');

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, enumerable: false, writable: true, configurable: true }
    });
    if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
}

var AsyncCreatableSelect = (function (_React$Component) {
    _inherits(AsyncCreatableSelect, _React$Component);

    function AsyncCreatableSelect() {
        _classCallCheck(this, AsyncCreatableSelect);

        return _possibleConstructorReturn(
            this,
            (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments)
        );
    }

    _createClass(AsyncCreatableSelect, [
        {
            key: 'focus',
            value: function focus() {
                this.select.focus();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;

                return _react2.default.createElement(_Async2.default, this.props, function (_ref) {
                    var ref = _ref.ref,
                        asyncProps = _objectWithoutProperties(_ref, ['ref']);

                    var asyncRef = ref;
                    return _react2.default.createElement(_Creatable2.default, asyncProps, function (_ref2) {
                        var ref = _ref2.ref,
                            creatableProps = _objectWithoutProperties(_ref2, ['ref']);

                        var creatableRef = ref;
                        return _this2.props.children(
                            _extends({}, creatableProps, {
                                ref: function ref(select) {
                                    creatableRef(select);
                                    asyncRef(select);
                                    _this2.select = select;
                                }
                            })
                        );
                    });
                });
            }
        }
    ]);

    return AsyncCreatableSelect;
})(_react2.default.Component);

var defaultChildren = function defaultChildren(props) {
    return _react2.default.createElement(_Select2.default, props);
};

AsyncCreatableSelect.propTypes = {
    children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
    children: defaultChildren
};

exports.default = AsyncCreatableSelect;
